import Reflux from 'reflux';

const KlarnaActions = Reflux.createActions([
  'getAddressesBySsn',
  'getAddressesBySsnComplete',
  'change'
]);

export default KlarnaActions;
